import React from "react";
import { AutoComplete } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllFilterEvents,
  updateSearchQuery,
} from "../../../Redux/slices/eventSlice";
import { useLocation, useNavigate } from "react-router-dom";
const AutoCompleteInputBar = (props) => {
  const { searchQuery } = useSelector((state) => state.event);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const updateSearch = (e) => {
    dispatch(updateSearchQuery(e));
    if (e.length === 0) dispatch(getAllFilterEvents());
    if (e.length > 2) {
      if (location.pathname !== "/events") {
        navigate("/events");
      }
      dispatch(getAllFilterEvents());
    }
  };

  const handleSearch = () => {
    console.log("Handle Search", searchQuery);
    dispatch(getAllFilterEvents());
  };

  return (
    <div className="input-container flex border-radius-14">
      <AutoComplete
        placeholder="Search for interests, categories, location or events..."
        onSearch={handleSearch}
        value={searchQuery}
        onChange={updateSearch}
      />
      {!props.removeSearch && <SearchOutlined />}
    </div>
  );
};

export default AutoCompleteInputBar;
